module.exports = __webpack_public_path__ + "static/media/fiji-airways.b2684015.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/LargeFlightCard/video/fiji-airways.jpg
// module id = 506
// module chunks = 0